import React, { Component } from 'react';
import {lang} from 'js/Core/lang';


export const  BookAppointPopup = ({statusSubmit, closePopup, clickOutSidePopup}) => {
    let className = statusSubmit === 'SUCCESS' ? 'popup--success' : 'popup--unsuccess';
    className += ' popup--submit';
    if(statusSubmit !== '' && statusSubmit !== 'NO PRODUCT'){
        let bodyEl = document.getElementsByTagName('html')[0];
        bodyEl.className  = 'popup-show';
    }  
    return (
        <section className="popup__overlay" onClick={e => clickOutSidePopup(e)}>
            <article className={`popup ${className}`}>
                <section className='popup__header'>
                    <div className='popup__title'>お知らせ</div>
                    <div className='popup__closer' onClick={e => closePopup()}></div>
                </section>
                <section className='popup__content'>
                    {
                        statusSubmit === 'SUCCESS' ? 
                        <div className="content"><span className="icon"></span><p dangerouslySetInnerHTML={{__html: lang.label.message_book_successfull}}></p></div> :
                        <div className="content">
                            <span className="icon"></span>
                            {
                                statusSubmit === 'NO PRODUCT' ? 
                                    <p dangerouslySetInnerHTML={{ __html: lang.txt.msg_no_product_timeline}}></p> : 
                                    statusSubmit === 'ERROR SERVER' ? 
                                    <p dangerouslySetInnerHTML={{__html: lang.message.msg_error_not_defined}}></p> : 
                                    <p dangerouslySetInnerHTML={{__html: lang.label.message_book_fail}}></p>
                            }
                        </div>
                    }
                </section>
                <section className='popup__footer'>
                </section>
            </article>
        </section>
    )
}